<style scoped>
    @import url("../../styles/smartControl/irrigSC.scss");
</style>

<template>
    <div class="box_irrigSC">

        <!-- MAIN TIT -->
        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-water</v-icon>
            <span class="ml-2">Irrigação</span>
        </div>

        <span v-if="flagOpenMsgErro">{{ msgErroIrrig  }}</span>

        <!-- Caixa de diálogo aberta após input de atualização -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div v-if="!flagLoading && flagDialog">
                <DialogMsg 
                v-if="flagDialog" 
                :msgFromFather="msg2child"
                @fromDialogMsg="flagDialog = false" 
                />
            </div>
        </v-dialog>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- definições gerais do sistema -->
        <div class="painelGeral" v-if="!flagLoading && !flagOpenMsgErro">

            <!-- selecionar alvo -->
            <AlvoFC :agent_unit="agent_unit" @fromChildUp="upDocInfoLast($event)" />

            <!-- btn control FORM exib -->
            <div class="btnOpenForm">

                <div class="tit_btn ml-6 mb-1">Inserir informação extra no sistema</div>
                
                <v-btn 
                @click="flagForm = !flagForm"
                height="60px"
                class="btnOpenForm_int mb-2"
                density="comfortable"
                :style="{'color':'green'}"
                >
                    <v-icon class="mr-1" size="16">mdi-plus</v-icon>
                    <span class="txt_btn_irrig">INFORMAR IRRIGAÇÃO EXTERNA</span>
                </v-btn>
                <!-- width="80%" -->
            </div>

            <!-- FORM LARGE -->
            <FormExtIrrig v-if="flagForm" class="hidden-sm-and-down"
            :agent_unit="agent_unit"
            :cl="$store.state.emailCliente"
            :sys_agend="$store.state.sistemaSC"
            :flagStrWrap="'no-wrap'"
            @fromChild2input="handleFromForm($event)" 
            />

            <!-- FORM SMALL -->
            <FormExtIrrig v-if="flagForm" class="hidden-md-and-up"
            :agent_unit="agent_unit"
            :cl="$store.state.emailCliente"
            :sys_agend="$store.state.sistemaSC"
            :flagStrWrap="'wrap'"
            @fromChild2input="handleFromForm($event)" 
            />

            <!-- corte de atuação por periodo -->
            <!-- opção de ter mais do que 1 regra de corte -->
            <!-- ex.: noite e final de semana -->
            <!--<PeriodoIrrigOFF v-if="!flagFormPeriodoOff"
            :agent_unit="agent_unit"
            @fromChildUp="handleFromHandleFormPeriodOFF($event)"
            />-->

            <PeriodoIrrigOFF_v2 v-if="!flagFormPeriodoOff"
            :agent_unit="agent_unit"
            />

            <!-- LARGE -->
            <FormPeriodoIrrigOFF v-if="flagFormPeriodoOff" class="hidden-sm-and-down"
            :infoP="infoPeriodoOff"
            :flagStrWrap="'no-wrap'"
            @fromChild2edit="fromChild2edit($event)" 
            @cancelEdit="flagFormPeriodoOff = $event"
            />

            <!-- SMALL -->
            <FormPeriodoIrrigOFF v-if="flagFormPeriodoOff" class="hidden-md-and-up"
            :infoP="infoPeriodoOff"
            :flagStrWrap="'wrap'"
            @fromChild2edit="fromChild2edit($event)" 
            @cancelEdit="flagFormPeriodoOff = $event"
            />

            <!-- LARGE | IRRIG -->
            <Graf class="" 
            :tit_a="'Umidade do solo %FC'"
            :tit_b="'Condutividade elétrica [uS/cm] (normalizada)'"
            :key_a="'u_fc'"
            :key_b="'conductivity'"
            :device_id_a="'upinc_i_u_fc'"
            :device_id_b="'ciam_i_u_fc_right'"
            :device_id_c="'upinc4_i_u_fc'"

            :main_tit="'Umidade do solo [%FC]'"
            :target_fc="target_u_fc"
            :flag_show_all="false"
            />

            <!-- LARGE | IRRIG -->
            <Graf class="hidden-sm-and-down" 
            :tit_a="'Umidade do solo [%bruto]'"
            :tit_b="'Condutividade elétrica [uS/cm] (normalizada)'"
            :key_a="'humidity'"
            :key_b="'conductivity'"
            :device_id_a="'soilconductivity'"
            :device_id_b="'soil-right'"
            :device_id_c="'upinc4_s_soil_1'"

            :main_tit="'Umidade do solo [%bruto]'"
            :target_fc="null"
            :flag_show_all="true"
            />

            <!-- histórico irrig -->
            <HistIrrig />

        </div>

    </div>
</template>

<script>
import axios from 'axios'

import AlvoFC from './subIrrigSC/AlvoFC'
import DialogMsg from './subIrrigSC/DialogMsg'
import FormExtIrrig from './subIrrigSC/FormExtIrrig'
import HistIrrig from './subIrrigSC/HistIrrig'
import FormPeriodoIrrigOFF from './subIrrigSC/FormPeriodoIrrigOFF'
//import PeriodoIrrigOFF from './subIrrigSC/PeriodoIrrigOFF'
import PeriodoIrrigOFF_v2 from './subIrrigSC/PeriodoIrrigOFF_v2'
import Graf from './subIrrigSC/GrafIrrig'

export default {

    components:{
        AlvoFC, 
        DialogMsg, 
        FormExtIrrig, 
        FormPeriodoIrrigOFF, 
        //PeriodoIrrigOFF, 
        PeriodoIrrigOFF_v2,
        HistIrrig, 
        Graf
    },

    data() {
        return {
            
            // -- sistema SC.
            flagMsgSistema:false, // sistema geral precisa estar definido para req init.
            msgSistema:'Selecione um sistema na página "Início"',

            // -- controle da atual página.
            flagLoading:false, // init true loading em produção
            flagDialog:false, // abrir e fechar dialog de confirmação após input
            msg2child:'', // msg no dialog final

            // -- op
            agent_unit:{},
            flagForm:false,
            target_u_fc:0,

            // -- op periodo off
            infoPeriodoOff:{
                'status':'on',
                'controlador':'teste controlador',
                'atuador':'teste atuador',
                'device_id':'teste device',
                'dt_str_init':'',
                'hhmm_init':'',
                'dt_str_end':'',
                'hhmm_end':''
            },
            flagFormPeriodoOff:false, // init com lista de atuadores exib

            // - erro
            flagOpenMsgErro:false,
            msgErroIrrig:'',
        }
    },

    methods:{

        handleFromHandleFormPeriodOFF(elPeriodOFF) {
            this.infoPeriodoOff = elPeriodOFF
            this.flagFormPeriodoOff = true // abrir edit
        },

        fromChild2edit(endForm) {

            // -- update.

            console.log('[fromChild2edit] form edit: ',endForm)
            
            this.flagFormPeriodoOff = false // desabilitar form input ext irrig

            this.flagLoading = true // -- open loading

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {
                'cliente':this.$store.state.emailCliente, 
                'sistema':this.$store.state.sistemaSC, 
                'el':endForm,
                'marcador':'irrig_period_off'
            }

            let self = this
            const url = self.$store.state.pathAxiosBASE + '/inxdocx'
            axios.post(url, params, {headers}).then(function (res) {

                console.log(res.data.result)
                const strConfirm = res.data.result

                if (strConfirm == 'edit-ok') {
                    
                    self.msg2child = 'Atualizado.'
                    //console.log(self.msg2child)
                }
                else {
                    
                    self.msg2child = 'Não foi possível atualizar. Tente novamente mais tarde.'
                    //console.log(self.msg2child)
                }
                self.flagDialog = true // abrir dialog com informações do input feito.

                // -- reset
                self.initInfo() // buscar a atualização realizada agora.
            })
        },

        handleFromForm(endForm) {

            // -- input.

            console.log('e: ',endForm)
            this.flagForm = false // desabilitar form input ext irrig

            this.flagLoading = true // -- open loading

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {
                'cliente':this.$store.state.emailCliente, 
                'sistema':this.$store.state.sistemaSC, 
                'el':endForm,
                'marcador':'irrig_in'
            }

            let self = this
            const url = self.$store.state.pathAxiosBASE + '/inxdocx'
            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                const strConfirm = res.data.result

                if (strConfirm == 'input-ok') {
                    
                    self.msg2child = 'Atualizado.'
                }
                else {
                    
                    self.msg2child = 'Não foi possível atualizar. Tente novamente mais tarde.'
                }
                self.flagDialog = true // abrir dialog com informações do input feito.

                // -- reset
                self.initInfo() // buscar a atualização realizada agora.
            })
        },

        upDocInfoLast(dictIrrigInfoLast) {

            // -- update estrutura.
            this.target_u_fc = dictIrrigInfoLast['target_fc']
            console.log('[irrigSC] after change target fc | new: ',this.target_u_fc)

            //console.log('dictIrrigInfoLast: ',dictIrrigInfoLast)

            this.flagLoading = true // -- open loading

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {'cliente':cl, 'sistema':this.sistema, 'el':dictIrrigInfoLast}

            let self = this
            const url = self.$store.state.pathAxiosBASE + '/upxdocx'
            axios.post(url, params, {headers}).then(function (res) {

                console.log(res.data.result) // agent 
                const strConfirm = res.data.result // agent_unit

                if (strConfirm == 'up-ok') {
                    
                    self.msg2child = 'Atualizado.'
                }
                else {
                    
                    self.msg2child = 'Não foi possível atualizar. Tente novamente mais tarde.'
                }
                self.flagDialog = true // abrir dialog com informações do input feito.

                // -- reset
                self.initInfo() // buscar a atualização realizada agora.
            })
        },

        async initInfo() {
            this.flagLoading = true // -- open loading

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            const res = await axios.post(self.$store.state.pathAxiosAgentIA, params, {headers})

            //console.log(res.data.result) // agent 
            this.agent_unit = res.data.result // agent_unit

            // -- verificar se existe a key de irrig antes de abrir.
            const flagE = Object.hasOwn(this.agent_unit, 'input_last_info')
            if (!flagE) { 
                this.flagOpenMsgErro = true
                this.msgErroIrrig = 'Análise de irrigação desabilitada' 
            }
            else{
                this.target_u_fc = this.agent_unit['input_last_info']['target_fc'] // string
                //console.log('[irrigSC] target_u_fc: ',this.target_u_fc)
            }

            this.flagLoading = false
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { this.initInfo() }
    }
}
</script>